import { FormattedMessage } from "react-intl";
import { useEffect } from "react";
// import { DropDown, DropDownRow } from "components";
// import { useSelector } from "redux/hooks";
// import { languages } from "utils/languages";
import { useState } from "react";
import { useWindowSize } from "hooks/useWindowSize";
// import { useIntl } from 'react-intl';

interface FilterBadgesProps {
  onFilterChange: (filterType: string) => void;
  webSearch?: boolean;
}

export const FilterBadges = ({
  onFilterChange,
  webSearch,
}: FilterBadgesProps) => {
  // const intl = useIntl();
  // const { theme } = useSelector((state) => state.authReducer);
  // const [language, setLanguage] = useState("");
  const [activeFilter, setActiveFilter] = useState("");
  const { width } = useWindowSize();
  const filters = [
    { id: "gptmodel.filterbadges.1", type: "multi" },
    { id: "gptmodel.filterbadges.2", type: "text" },
    { id: "gptmodel.filterbadges.3", type: "image" },
    { id: "gptmodel.filterbadges.4", type: "websearch" },
    // { id: "gptmodel.filterbadges.5", type: "language" },
  ];

  // const onUpdateLanguage = useCallback((lang: string) => {
  //     setLanguage(lang);
  // }, []);

  //   const clearLanguage = useCallback(() => {
  //     debugger
  //     setLanguage("");
  // }, []);

  const handleFilterClick = (filterType: string) => {
    // Toggle the filter if it's already active
    const newFilter = activeFilter === filterType ? "" : filterType;
    setActiveFilter(newFilter);
    onFilterChange(newFilter);
  };

  useEffect(() => {
    if (webSearch) {
      handleFilterClick("websearch");
    }
  }, [webSearch]);

  return (
    <div className="flex overflow-x-auto whitespace-nowrap gap-2 overflow-y-hidden pb-2">
      {filters.map((filter, index) => (
        // filter.id === "gptmodel.filterbadges.5" ? (
        //   <DropDown
        //     variant={theme}
        //     options={languages}
        //     value={language}
        //     onChange={(item: DropDownRow.IDataItem) =>
        //         onUpdateLanguage(item.value)
        //     }
        //     placeholder={intl.formatMessage({ id: filter.id })}
        //     className={`${language ? "bg-[#4338CA]" : "bg-[#EDF4FE]"} rounded-[8px] text-[#525252] text-[14px] font-inter font-medium`}
        //     account={true}
        //     filtergptModelLanguage={true}
        //     onClearValue={clearLanguage}
        // />
        // )  : (
        <button
          key={index}
          className={`px-3 py-2 rounded-[8px] font-inter font-medium ${width <= 576 ? "text-[12px]" : "text-[14px]"} ${activeFilter === filter.type ? "bg-[#4338CA] text-white" : "bg-[#EDF4FE] text-[#525252]"}`}
          onClick={() => handleFilterClick(filter.type)}
        >
          <FormattedMessage id={filter.id} />
        </button>
        // )
      ))}
    </div>
  );
};
